// angle down

export const chevronDown = `<svg aria-hidden="true" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 32">
<path d="M8.938 22.019l-8.5-8.5c-0.588-0.587-0.588-1.537 0-2.119l1.412-1.413c0.588-0.587 1.538-0.587 2.119 0l6.025 6.025 6.025-6.025c0.588-0.587 1.538-0.587 2.119 0l1.412 1.413c0.588 0.587 0.588 1.537 0 2.119l-8.5 8.5c-0.575 0.588-1.525 0.588-2.113 0z"></path>
</svg>`;
